/**
 * @flow
 * @relayHash 0feb132cd539fa65fdabe15502cd0ac3
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type ElectRoleFillerSelect_proposal$ref = any;
type ElectRoleFiller_change$ref = any;
type LinkedRole_change$ref = any;
type MoveItems_change$ref = any;
type PolicySelect_proposal$ref = any;
type Policy_change$ref = any;
type ProposeNowButton_proposal$ref = any;
type RoleSelect_proposal$ref = any;
type Role_change$ref = any;
type SupportedRoleSelect_proposal$ref = any;
export type AddProposalChangeInput = {|
  clientMutationId?: ?string,
  context: MutationContext,
  proposalId: string,
  command: any,
  meetingId?: ?string,
|};
export type MutationContext = {|
  organizationId: string
|};
export type AddProposalChangeMutationVariables = {|
  input: AddProposalChangeInput
|};
export type AddProposalChangeMutationResponse = {|
  +addProposalChange: ?{|
    +changeEdge: ?{|
      +node: ?{|
        +id: string,
        +databaseId: string,
        +$fragmentRefs: LinkedRole_change$ref & Role_change$ref & Policy_change$ref & MoveItems_change$ref & ElectRoleFiller_change$ref,
      |}
    |},
    +proposal: ?{|
      +$fragmentRefs: RoleSelect_proposal$ref & PolicySelect_proposal$ref & ElectRoleFillerSelect_proposal$ref & SupportedRoleSelect_proposal$ref & ProposeNowButton_proposal$ref
    |},
  |}
|};
export type AddProposalChangeMutation = {|
  variables: AddProposalChangeMutationVariables,
  response: AddProposalChangeMutationResponse,
|};
*/


/*
mutation AddProposalChangeMutation(
  $input: AddProposalChangeInput!
) {
  addProposalChange(input: $input) {
    changeEdge {
      node {
        __typename
        id
        databaseId
        ...LinkedRole_change
        ...Role_change
        ...Policy_change
        ...MoveItems_change
        ...ElectRoleFiller_change
      }
    }
    proposal {
      ...RoleSelect_proposal
      ...PolicySelect_proposal
      ...ElectRoleFillerSelect_proposal
      ...SupportedRoleSelect_proposal
      ...ProposeNowButton_proposal
      id
    }
  }
}

fragment Accountabilities_circle on Circle {
  databaseId
}

fragment ElectRoleFillerSelect_proposal on Proposal {
  databaseId
  availableElectedRoles: availableRoles(elected: true) {
    edges {
      currentlyHoldingElection
      node {
        databaseId
        localizedName
        id
      }
    }
  }
}

fragment ElectRoleFiller_change on DescribeChangeable {
  __isDescribeChangeable: __typename
  id
  databaseId
  command
  type
  alerts {
    path
    message
    severity
  }
  ... on ElectRoleFillerChange {
    organization {
      autocompletePeople(first: 10000) {
        name
        databaseId
      }
      id
    }
    assignedUntil
    person {
      databaseId
      name
      id
    }
    role {
      databaseId
      localizedName
      id
    }
  }
}

fragment LinkedRole_change on DescribeChangeable {
  __isDescribeChangeable: __typename
  id
  databaseId
  type
  ... on LinkedRoleChange {
    availableRoles(first: 100) {
      edges {
        node {
          databaseId
          localizedName
          circle {
            localizedName
            id
          }
          id
        }
      }
    }
    circle {
      databaseId
      localizedName
      ...Accountabilities_circle
      id
    }
    originalRole {
      databaseId
      localizedName
      purpose
      id
    }
    linkedRole {
      databaseId
      localizedName
      accountabilities(first: 100) {
        edges {
          node {
            databaseId
            description
            isProtected
            id
          }
        }
      }
      domains(first: 100) {
        edges {
          node {
            databaseId
            description
            isProtected
            id
          }
        }
      }
      originalRole {
        databaseId
        localizedName
        purpose
        circle {
          localizedName
          id
        }
        accountabilities(first: 100) {
          edges {
            node {
              databaseId
              description
              isProtected
              id
            }
          }
        }
        domains(first: 100) {
          edges {
            node {
              databaseId
              description
              isProtected
              id
            }
          }
        }
        id
      }
      id
    }
  }
  ...SummarySections_change
  command
  alerts {
    path
    message
    severity
  }
}

fragment MoveItems_change on DescribeChangeable {
  __isDescribeChangeable: __typename
  id
  databaseId
  command
  type
  alerts {
    path
    message
    severity
  }
  ... on MoveItemsChange {
    role {
      databaseId
      circlePolicies {
        edges {
          node {
            databaseId
            displayName: title
            resourcePath
            id
          }
        }
      }
      circleRoles {
        edges {
          node {
            databaseId
            displayName: localizedName
            resourcePath
            id
          }
        }
      }
      id
    }
    childSupportedRole {
      databaseId
      localizedName
      circlePolicies {
        edges {
          node {
            databaseId
            displayName: title
            resourcePath
            id
          }
        }
      }
      circleRoles {
        edges {
          node {
            databaseId
            displayName: localizedName
            resourcePath
            id
          }
        }
      }
      id
    }
    roleHasBeenRemoved
    policiesToMoveUp {
      databaseId
      id
    }
    policiesToMoveDown {
      databaseId
      id
    }
    rolesToMoveUp {
      databaseId
      id
    }
    rolesToMoveDown {
      databaseId
      id
    }
  }
}

fragment PolicySelect_proposal on Proposal {
  databaseId
  availablePolicies {
    edges {
      currentlyUpdating
      node {
        databaseId
        title
        domain {
          databaseId
          id
        }
        id
      }
    }
  }
}

fragment Policy_change on DescribeChangeable {
  __isDescribeChangeable: __typename
  ... on PolicyChange {
    availableDomains(first: 100) {
      edges {
        node {
          databaseId
          description(format: PLAIN)
          id
        }
      }
    }
    policyHasBeenRemoved
    policy {
      databaseId
      title
      body
      domain {
        databaseId
        description
        id
      }
      id
    }
  }
  ...SummarySections_change
  command
  databaseId
  id
  type
  alerts {
    path
    message
    severity
  }
}

fragment ProposeNowButton_proposal on Proposal {
  ...ProposeNow_proposal
}

fragment ProposeNow_proposal on Proposal {
  id
  status
  databaseId
  canBeAccepted
  hasChanges
  expectedResponseCount
  organization {
    asyncProposalsAreEnabled
    id
  }
  circle {
    isGovernanceEnabled
    id
  }
}

fragment RoleSelect_proposal on Proposal {
  databaseId
  viewerCanLinkRole
  organization {
    onRestrictedPlan
    isOnV5
    id
  }
  circle {
    databaseId
    id
  }
  availableRoles {
    edges {
      currentlyUpdating
      node {
        databaseId
        localizedName
        isLinked
        id
      }
    }
  }
}

fragment Role_change on DescribeChangeable {
  __isDescribeChangeable: __typename
  ... on RoleChange {
    role {
      circlePolicies {
        edges {
          node {
            databaseId
            displayName: title
            id
          }
        }
      }
      circleRoles {
        edges {
          node {
            databaseId
            displayName: localizedName
            id
          }
        }
      }
      id
      databaseId
      name: localizedName
      localizedName
      rawPurpose: purpose(format: RAW)
      mdPurpose: purpose(format: MARKDOWN)
      isProtected
      supportingCircle {
        id
      }
      circle {
        supportedRole {
          databaseId
          id
        }
        id
      }
      domains(first: 100) {
        edges {
          node {
            databaseId
            rawDescription: description(format: RAW)
            markdownDescription: description(format: MARKDOWN)
            isProtected
            id
          }
        }
      }
      accountabilities(first: 100) {
        edges {
          node {
            databaseId
            rawDescription: description(format: RAW)
            markdownDescription: description(format: MARKDOWN)
            isProtected
            id
          }
        }
      }
    }
    circle {
      databaseId
      localizedName
      shortName
      supportedRole {
        databaseId
        id
      }
      policies(first: 100) {
        edges {
          node {
            databaseId
            displayName: title
            id
          }
        }
      }
      roles(first: 100) {
        edges {
          node {
            databaseId
            displayName: localizedName
            isProtected
            id
          }
        }
      }
      id
    }
    roleHasBeenRemoved
    organization {
      isWysiwygEnabled
      isOnV4
      id
    }
    rolesToMoveDown {
      databaseId
      id
    }
    rolesToMoveUp {
      databaseId
      id
    }
    policiesToMoveDown {
      databaseId
      id
    }
    policiesToMoveUp {
      databaseId
      id
    }
  }
  ...SummarySections_change
  command
  databaseId
  id
  type
  alerts {
    path
    message
    severity
  }
}

fragment SummarySections_change on DescribeChangeable {
  __isDescribeChangeable: __typename
  summary {
    title
    sections
  }
}

fragment SupportedRoleSelect_proposal on Proposal {
  databaseId
  availableSupportedRoles {
    edges {
      currentlyUpdating
      node {
        databaseId
        localizedName
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "databaseId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedName",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "Circle",
  "kind": "LinkedField",
  "name": "circle",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    (v2/*: any*/)
  ],
  "storageKey": null
},
v8 = [
  (v3/*: any*/),
  (v6/*: any*/),
  (v2/*: any*/)
],
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "purpose",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isProtected",
  "storageKey": null
},
v12 = [
  (v3/*: any*/),
  (v10/*: any*/),
  (v11/*: any*/),
  (v2/*: any*/)
],
v13 = {
  "alias": null,
  "args": (v5/*: any*/),
  "concreteType": "AccountabilityConnection",
  "kind": "LinkedField",
  "name": "accountabilities",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "AccountabilityEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Accountability",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v12/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "accountabilities(first:100)"
},
v14 = {
  "alias": null,
  "args": (v5/*: any*/),
  "concreteType": "DomainConnection",
  "kind": "LinkedField",
  "name": "domains",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "DomainEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Domain",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": (v12/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "domains(first:100)"
},
v15 = {
  "alias": "displayName",
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v16 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "PolicyEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Policy",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v15/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v17 = {
  "alias": "displayName",
  "args": null,
  "kind": "ScalarField",
  "name": "localizedName",
  "storageKey": null
},
v18 = [
  {
    "kind": "Literal",
    "name": "format",
    "value": "RAW"
  }
],
v19 = [
  {
    "kind": "Literal",
    "name": "format",
    "value": "MARKDOWN"
  }
],
v20 = [
  (v3/*: any*/),
  (v2/*: any*/)
],
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "supportedRole",
  "plural": false,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v22 = [
  (v3/*: any*/),
  {
    "alias": "rawDescription",
    "args": (v18/*: any*/),
    "kind": "ScalarField",
    "name": "description",
    "storageKey": "description(format:\"RAW\")"
  },
  {
    "alias": "markdownDescription",
    "args": (v19/*: any*/),
    "kind": "ScalarField",
    "name": "description",
    "storageKey": "description(format:\"MARKDOWN\")"
  },
  (v11/*: any*/),
  (v2/*: any*/)
],
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "roleHasBeenRemoved",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "rolesToMoveDown",
  "plural": true,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "rolesToMoveUp",
  "plural": true,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Policy",
  "kind": "LinkedField",
  "name": "policiesToMoveDown",
  "plural": true,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "Policy",
  "kind": "LinkedField",
  "name": "policiesToMoveUp",
  "plural": true,
  "selections": (v20/*: any*/),
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "resourcePath",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "PolicyConnection",
  "kind": "LinkedField",
  "name": "circlePolicies",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PolicyEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Policy",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v15/*: any*/),
            (v28/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "concreteType": "RoleConnection",
  "kind": "LinkedField",
  "name": "circleRoles",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "RoleEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v17/*: any*/),
            (v28/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentlyUpdating",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "concreteType": "Role",
  "kind": "LinkedField",
  "name": "node",
  "plural": false,
  "selections": (v8/*: any*/),
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AddProposalChangeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddProposalChangePayload",
        "kind": "LinkedField",
        "name": "addProposalChange",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DescribeChangeableEdge",
            "kind": "LinkedField",
            "name": "changeEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "LinkedRole_change"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "Role_change"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "Policy_change"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MoveItems_change"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ElectRoleFiller_change"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Proposal",
            "kind": "LinkedField",
            "name": "proposal",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "RoleSelect_proposal"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PolicySelect_proposal"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ElectRoleFillerSelect_proposal"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SupportedRoleSelect_proposal"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ProposeNowButton_proposal"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AddProposalChangeMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AddProposalChangePayload",
        "kind": "LinkedField",
        "name": "addProposalChange",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "DescribeChangeableEdge",
            "kind": "LinkedField",
            "name": "changeEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isDescribeChangeable"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "type",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ChangeSummary",
                    "kind": "LinkedField",
                    "name": "summary",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sections",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "command",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Alert",
                    "kind": "LinkedField",
                    "name": "alerts",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "path",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "message",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "severity",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": (v5/*: any*/),
                        "concreteType": "RoleConnection",
                        "kind": "LinkedField",
                        "name": "availableRoles",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoleEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Role",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "availableRoles(first:100)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Circle",
                        "kind": "LinkedField",
                        "name": "circle",
                        "plural": false,
                        "selections": (v8/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "originalRole",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v6/*: any*/),
                          (v9/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "linkedRole",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v6/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Role",
                            "kind": "LinkedField",
                            "name": "originalRole",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v6/*: any*/),
                              (v9/*: any*/),
                              (v7/*: any*/),
                              (v13/*: any*/),
                              (v14/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "LinkedRoleChange",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "role",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PolicyConnection",
                            "kind": "LinkedField",
                            "name": "circlePolicies",
                            "plural": false,
                            "selections": (v16/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoleConnection",
                            "kind": "LinkedField",
                            "name": "circleRoles",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RoleEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Role",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v17/*: any*/),
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          (v3/*: any*/),
                          {
                            "alias": "name",
                            "args": null,
                            "kind": "ScalarField",
                            "name": "localizedName",
                            "storageKey": null
                          },
                          (v6/*: any*/),
                          {
                            "alias": "rawPurpose",
                            "args": (v18/*: any*/),
                            "kind": "ScalarField",
                            "name": "purpose",
                            "storageKey": "purpose(format:\"RAW\")"
                          },
                          {
                            "alias": "mdPurpose",
                            "args": (v19/*: any*/),
                            "kind": "ScalarField",
                            "name": "purpose",
                            "storageKey": "purpose(format:\"MARKDOWN\")"
                          },
                          (v11/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Circle",
                            "kind": "LinkedField",
                            "name": "supportingCircle",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Circle",
                            "kind": "LinkedField",
                            "name": "circle",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v5/*: any*/),
                            "concreteType": "DomainConnection",
                            "kind": "LinkedField",
                            "name": "domains",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "DomainEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Domain",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v22/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "domains(first:100)"
                          },
                          {
                            "alias": null,
                            "args": (v5/*: any*/),
                            "concreteType": "AccountabilityConnection",
                            "kind": "LinkedField",
                            "name": "accountabilities",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "AccountabilityEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Accountability",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": (v22/*: any*/),
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "accountabilities(first:100)"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Circle",
                        "kind": "LinkedField",
                        "name": "circle",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "shortName",
                            "storageKey": null
                          },
                          (v21/*: any*/),
                          {
                            "alias": null,
                            "args": (v5/*: any*/),
                            "concreteType": "PolicyConnection",
                            "kind": "LinkedField",
                            "name": "policies",
                            "plural": false,
                            "selections": (v16/*: any*/),
                            "storageKey": "policies(first:100)"
                          },
                          {
                            "alias": null,
                            "args": (v5/*: any*/),
                            "concreteType": "RoleConnection",
                            "kind": "LinkedField",
                            "name": "roles",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "RoleEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Role",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v17/*: any*/),
                                      (v11/*: any*/),
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": "roles(first:100)"
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v23/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Organization",
                        "kind": "LinkedField",
                        "name": "organization",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isWysiwygEnabled",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isOnV4",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v24/*: any*/),
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/)
                    ],
                    "type": "RoleChange",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": (v5/*: any*/),
                        "concreteType": "DomainConnection",
                        "kind": "LinkedField",
                        "name": "availableDomains",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "DomainEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Domain",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "format",
                                        "value": "PLAIN"
                                      }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "description",
                                    "storageKey": "description(format:\"PLAIN\")"
                                  },
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "availableDomains(first:100)"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "policyHasBeenRemoved",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Policy",
                        "kind": "LinkedField",
                        "name": "policy",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "body",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Domain",
                            "kind": "LinkedField",
                            "name": "domain",
                            "plural": false,
                            "selections": [
                              (v3/*: any*/),
                              (v10/*: any*/),
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "PolicyChange",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "role",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v29/*: any*/),
                          (v30/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "childSupportedRole",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v6/*: any*/),
                          (v29/*: any*/),
                          (v30/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v23/*: any*/),
                      (v27/*: any*/),
                      (v26/*: any*/),
                      (v25/*: any*/),
                      (v24/*: any*/)
                    ],
                    "type": "MoveItemsChange",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Organization",
                        "kind": "LinkedField",
                        "name": "organization",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "first",
                                "value": 10000
                              }
                            ],
                            "concreteType": "AutocompletePerson",
                            "kind": "LinkedField",
                            "name": "autocompletePeople",
                            "plural": true,
                            "selections": [
                              (v31/*: any*/),
                              (v3/*: any*/)
                            ],
                            "storageKey": "autocompletePeople(first:10000)"
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "assignedUntil",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Person",
                        "kind": "LinkedField",
                        "name": "person",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v31/*: any*/),
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "role",
                        "plural": false,
                        "selections": (v8/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "type": "ElectRoleFillerChange",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Proposal",
            "kind": "LinkedField",
            "name": "proposal",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "viewerCanLinkRole",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Organization",
                "kind": "LinkedField",
                "name": "organization",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "onRestrictedPlan",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isOnV5",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "asyncProposalsAreEnabled",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Circle",
                "kind": "LinkedField",
                "name": "circle",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v2/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isGovernanceEnabled",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AvailableRolesConnection",
                "kind": "LinkedField",
                "name": "availableRoles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AvailableRolesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v32/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Role",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v6/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "isLinked",
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AvailablePoliciesConnection",
                "kind": "LinkedField",
                "name": "availablePolicies",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AvailablePoliciesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v32/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Policy",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Domain",
                            "kind": "LinkedField",
                            "name": "domain",
                            "plural": false,
                            "selections": (v20/*: any*/),
                            "storageKey": null
                          },
                          (v2/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "availableElectedRoles",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "elected",
                    "value": true
                  }
                ],
                "concreteType": "AvailableRolesConnection",
                "kind": "LinkedField",
                "name": "availableRoles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AvailableRolesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "currentlyHoldingElection",
                        "storageKey": null
                      },
                      (v33/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "availableRoles(elected:true)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "AvailableSupportedRolesConnection",
                "kind": "LinkedField",
                "name": "availableSupportedRoles",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AvailableSupportedRolesEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v32/*: any*/),
                      (v33/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "canBeAccepted",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasChanges",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "expectedResponseCount",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "0feb132cd539fa65fdabe15502cd0ac3",
    "metadata": {},
    "name": "AddProposalChangeMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '37100178f66ad219eb21949e3a70b467';

module.exports = node;
